import React from 'react';

import {
  Button,
  FlexItem,
  SplitLayout, StackLayout,
} from '@salt-ds/core';
import {TriangleLeftIcon} from '@salt-ds/icons';
import {useNavigate} from 'react-router';

function PageNavigation(props) {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/");
  }

  const handlePrevious = () => {
    navigate(props.previousPage, {state: {from: props.currentPage}});
  }

  const startItem = <StackLayout direction={{
    sm: "row"
  }} gap={1}>
    <FlexItem>
      <Button sentiment="accented" appearance="transparent" onClick={handleBackToLogin} style={{
        // width: "100%"
      }}
        disabled={props.disabled}
      >
        CANCEL
      </Button>
    </FlexItem>
  </StackLayout>;

  const endItem = <StackLayout direction={{
    // xs: "column",
    sm: "row"
  }} gap={2}>
    {props.backButton &&
      <FlexItem>
        <Button sentiment="accented" appearance="transparent" onClick={handlePrevious} style={{
          // width: "100%"
        }}>
          <TriangleLeftIcon aria-hidden />
          BACK
        </Button>
      </FlexItem>}
    <FlexItem>
      <Button sentiment="accented" appearance="solid" type="submit" style={{
        // width: "100%"
      }}
        onClick={props.sendToHome}
        disabled={props.disabled}
      >
        {props.isContinue ? props.buttonText : "NEXT"}
      </Button>
    </FlexItem>
  </StackLayout>;

  return (
    <SplitLayout startItem={startItem} endItem={endItem} gap={1} direction={{
      // xs: "column",
      sm: "row"
    }} style={props.style} />)
}

export default PageNavigation;